import * as React from 'react';

import { makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    /* width: theme.spacing(3),
    height: theme.spacing(3), */
  },
}));

const ActionsField = ({
  tipo,
  handleEdit,
  handleDelete,
  handleEfetivar,
  ...rest
}) => {
  const classes = useStyles();
  // const { source } = rest;
  const statusValue = rest ? rest.record.status : false;
  const disaledDelete = rest
    ? rest.record.parcela_venda_id || rest.record.parcela_compra_id
    : false;

  const disabledEdit = rest
    ? (rest.record.conta.is_caixa && !!rest.record.parcela_venda_id) ||
      (rest.record.conta.is_caixa && !rest.record.is_transferencia)
    : false;

  return (
    <div style={{ marginRight: '0px' }}>
      {tipo !== 'Transferência' && !statusValue && (
        <Tooltip title="Efetivar" placement="bottom" aria-label="add2">
          <IconButton
            aria-label="check"
            classes={{ root: classes.root }}
            size="small"
            onClick={() => handleEfetivar(rest)}
          >
            <CheckCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Editar" placement="bottom" aria-label="add2">
        <IconButton
          aria-label="edit"
          classes={{ root: classes.root }}
          size="small"
          onClick={() => handleEdit(rest)}
          disabled={disabledEdit}
        >
          <EditOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Deletar" placement="bottom" aria-label="add2">
        <IconButton
          aria-label="delete"
          classes={{ root: classes.root }}
          size="small"
          onClick={() => handleDelete(rest)}
          disabled={disaledDelete}
        >
          <DeleteOutlineIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ActionsField;
